



















































































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Input, Button, Checkbox, Message,
} from 'element-ui';
import Sign from '@/servers/modules/signinsignup'; // server
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';

@Component({
  components: {
    Input,
    Button,
    Checkbox,
    Message,
  },
})
export default class extends Vue {
    @Mutation public saveBasicData;

    @Mutation public saveLSBasicData;

    @Mutation public setNavData;

    @Getter public basicData: any;

    private isShowPropo = 'yes-show';

    private form: any = {
      loginName: '',
      password: '',
    }

    private toUrl(obj:object) {
      if (obj.type === '1') {
        window.open('https://www.ambow.com/');
        return;
      }
      this.type = obj.type;
      // this.$router.push({path:'about',query:{"type" : obj.type }});
    }

    private updateType(data:string) {
      if (data === '1') {
        this.$router.push({ name: 'login' });
        return;
      }
      this.type = data;
    }

    // auto login
    private auto: boolean = true;

    private type: string = '';

    // loading
    private loading: boolean = false;

    // 登录按钮绑定回车键
    private keyupHandled(event: any) {
      // 回车登录
      if (event.keyCode == 13) {
        this.login();
      }
    }

    mounted() {
      this.type = this.$route.query.type;
    }

    private created() {
      window.addEventListener('keyup', this.keyupHandled);
    }

    private beforeDestroy() {
      window.removeEventListener('keyup', this.keyupHandled);
    }

    private get usernameValue() {
      return this.form.loginName;
    }

    // 去注册
    private signup() {
      this.$router.push({ name: 'join' });
    }
}
